import { Link } from 'react-router-dom';
import Logo from '../components/ui/Logo';
import Btn from '../components/ui/Btn';
import { Card } from '../components/ui/primitives';
import { Icon } from '../components/ui/Icon';

export default function NotFound() {
  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    }}>
      <Card style={{ padding: 32, maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}>
          <Logo size={44} useFile />
        </div>
        <h1 style={{ fontSize: 48, fontWeight: 800, letterSpacing: '-0.04em', color: 'var(--text)', lineHeight: 1 }}>
          404
        </h1>
        <p style={{ fontSize: 14, color: 'var(--text-3)', marginTop: 8, marginBottom: 20 }}>
          That page doesn't exist (yet).
        </p>
        <Link to="/hub" style={{ textDecoration: 'none', display: 'inline-block' }}>
          <Btn variant="primary" size="md" icon={Icon.home}>
            Back to Hub
          </Btn>
        </Link>
      </Card>
    </div>
  );
}
